import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    token:'',
    webId:''
  },
  mutations: {
    setToken(state,token){
      state.token = token;
    },
    setWebId(state,webId){
      state.webId = webId;
    }
  },
  actions: {

  }
})
